import React, { Component } from 'react'

export default class MovieIteam extends Component {

  render() {

    let { title, overview, imageurl, release_date, imdb, urlId } = this.props;

    return (
      <div className='my-3'>
        <div className="card text-dark bg-light" >
          <a href={urlId} target="_blank" rel="noreferrer">
            <img src={imageurl} className="card-img-top" alt="Card image cap" />
          </a>

          <div className="card-body">
            <a href={urlId} style={{ textDecoration: "none" }} target="_blank" rel="noreferrer">
              <b><h6 className="card-title text-success" style={{ fontSize: "18px" }}>{title}</h6></b></a>
            <p className="card-text text-secondary" style={{ fontSize: "14px" }}>{overview}...</p>
            <p className='card-text'> <span className="badge text-bg-success">
              {"Relese-Date : "+release_date}
            </span>
            </p>
            <span className="badge text-bg-success">
              {"IMDB : "+imdb}
            </span>
          </div>
        </div>
      </div >
    )
  }
}

